
import XHeader from 'vux/src/components/x-header/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Search from 'vux/src/components/search/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { request, setToken } from "../../utils/axios";

export default {
directives: {
TransferDom,
},
components: {
XHeader,
Actionsheet,
ButtonTab,
ButtonTabItem,
XTable,
Group,
Cell,
CellFormPreview,
CellBox,
Badge,
Card,
Divider,
Tabbar,
TabbarItem,
Search,
XButton,
XInput,
XTextarea,
Datetime,
Toast,
XDialog,
Flexbox,
FlexboxItem,
Loading,
},
data() {
return {
showContent004: true,
value1: "2015-11-12",
show3: false,
showContent005: false,
showHideOnBlur: false,
enterFlag: null,
detailData: {}, //详情信息
input1: "", //单据
documentInfo: [], //单据信息
insertData: [], //进厂信息
outData: [], //出厂信息
dataFlag: "", //判断是进厂信息还是出厂信息
modalList: [], //弹窗内显示的单据信息
opinionFlag: false,
dateinfo: "",
opinion: "",
siteList: [
{ value: "A050", meaning: "内蒙大全一期" },
{ value: "A051", meaning: "内蒙大全二期" },
{ value: "A070", meaning: "内蒙半导体" },
{ value: "A090", meaning: "内蒙研究院" },
], //工厂信息
appointmentType: [
{ value: "VEHICLE", meaning: "车辆" },
{ value: "UN_VEHICLE", meaning: "非车辆" },
],
gateSentry: [
{ value: "4", meaning: "4号门岗" },
{ value: "else", meaning: "其他" },
], //门岗
siteFlag: false, //工厂弹窗
appointmentTypeFlag: false, //类型弹窗
gateSentryFlag: false, //门岗弹窗
show2: true,
show4: false,
show5: false,
Datetime: "请选择进厂的时间",
show6: false,
show7: false,
show8: false,
enableFlag: false,
message: "",
failedMessage:'',
};
},
beforeMount() {
this.init();
},
beforeDestroy() {

sessionStorage.removeItem("routerPush");
},

methods: {
init() {

if (this.$route.params.reservationDocId) {
request(
"get",
`/hitf/v2p/rest/invoke/mt-reservation-docsDetail?reservationDocId=${this.$route.params.reservationDocId}`
)
.then((response) => {
this.detailData = response.data;
this.show2 = false;
this.insertData = this.detailData.list.filter(
(item) => item.reservationMaterialType === "INTO"
);
this.outData = this.detailData.list.filter(
(item) => item.reservationMaterialType === "OUT"
);

this.dateinfo = response.data.estimatedArrivalTime.slice(0, -3);
})
.catch((error) => {
console.error("Error fetching data:", error);
});
} else {
this.enableFlag = true; 
this.show2 = false;
}
if (this.$route.query.usertoken) {
request(
"get",
`/oauth/public/weaver/query/user/code?usertoken=${this.$route.query.usertoken}`
)
.then((response) => {
sessionStorage.setItem("userNum", response.data);
this.detailData.auditBy = response.data;
})
.catch((error) => {
console.error("Error fetching data:", error);
});
}
},
handleBack() {
console.log(this.$router.history.current);
if (sessionStorage.getItem("routerPush")) {
console.log("返回上一级");

this.$router.go(-1);
sessionStorage.removeItem("routerPush");
} else {
console.log("跳转");

this.$router.push({
path: `/appointment-form-management/home`,
});
sessionStorage.removeItem("routerPush");
}


},

reject() {
if (this.opinion !== "") {
this.detailData.auditOpinion = this.opinion;
delete this.detailData.list;
this.detailData.reservationDocStatus = "REFUSED";
this.detailData.auditBy = sessionStorage.getItem("userNum");

request("post", `/hitf/v2p/rest/invoke/mtReservationDocsApprove`, [
this.detailData,
]).then((res) => {
if (!res.failed) {
this.opinionFlag = false;
this.show4 = true;
let params = {};
params.const1 = "已驳回";
params.car_number2 = this.detailData.vehicleCode;
params.thing9 = this.detailData.driver;
params.phone_number10 = this.detailData.driverPhone;

params.time3 = this.detailData.estimatedArrivalTime;
request(
"post",
`/hitf/v2p/rest/invoke/wenxinSendMessage?openId=${this.detailData.reservationBy}&reservationDocId=${this.detailData.reservationDocNum}`,
params
).then((res1) => {
console.log(res1);
this.handleBack();
});

} else {
this.show5 = true;
}
});
} else {
this.show8 = true;
}
},
pass() {
this.detailData.auditOpinion = this.opinion;
delete this.detailData.list;
this.detailData.reservationDocStatus = "APPROVED";
this.detailData.auditBy = sessionStorage.getItem("userNum");

request("post", `/hitf/v2p/rest/invoke/mtReservationDocsApprove`, [
this.detailData,
]).then((res) => {
if (!res.failed) {
this.opinionFlag = false;
this.show4 = true;
let params = {};
params.const1 = "已通过";
params.car_number2 = this.detailData.vehicleCode;
params.thing9 = this.detailData.driver;
params.phone_number10 = this.detailData.driverPhone;

params.time3 = this.detailData.estimatedArrivalTime;
request(
"post",
`/hitf/v2p/rest/invoke/wenxinSendMessage?openId=${this.detailData.reservationBy}&reservationDocId=${this.detailData.reservationDocNum}`,
params
).then((res1) => {
console.log(res1);

this.handleBack();
});
} else {
this.show5 = true;
}
});
},


handleSubmit() {
this.opinionFlag = true;
},

transformData(inputArray, type) {
return inputArray
.map((item) => {

const instructionDocNum = item.instructionDocNum;
const site = item.siteCode;
const instructionDocType = item.instructionDocType; 
const instructionDocTypeMeaning = item.instructionDocTypeMeaning; 
const reservationMaterialType = type; 
const supplierCode = item.supplierCode; 
const supplierName = item.supplierName; 
const customerCode = item.customerCode; 
const customerName = item.customerName; 
const contactPerson = item.contactPerson
? item.contactPerson
: item.creationPerson; // 假设固定值
const instructionNum = item.instructionNum; 


return item.lineList.map((line) => {
return {
instructionDocNum, // 保持原有的文档编号
site, // 保持原有的站点
instructionDocType, // 固定的文档类型
reservationMaterialType, // 固定的物料类型

materialCode: line.materialCode, // 从 lineList 中获取 materialCode
materialName: line.materialName, // 从 lineList 中获取 materialName
qty: parseFloat(line.qty).toFixed(2), // 将数量转换为数字，保留两位小数
uom: line.uom, // 从 lineList 中获取单位
supplierCode, // 固定值
supplierName, // 固定值
customerCode, // 固定值
customerName, // 固定值
contactPerson, // 固定值
instructionNum: instructionNum ? instructionNum : line.lineNum,
instructionDocTypeMeaning,
};
});
})
.flat(); // 使用 flat() 使得每个 lineList 数组扁平化到同一层级
},
},
};



// WEBPACK FOOTER //
// ./src/views/AppointmentFormManagement/detail.vue